import { render } from "./InterestCard.vue?vue&type=template&id=4510cdfe&scoped=true"
import script from "./InterestCard.vue?vue&type=script&lang=js"
export * from "./InterestCard.vue?vue&type=script&lang=js"

import "./InterestCard.vue?vue&type=style&index=0&id=4510cdfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4510cdfe"]])

export default __exports__